// extracted by css-extract-rspack-plugin
export default {"Label":"Label-module__Label__WyIUk","Icon":"Label-module__Icon__SbhJf"};